import ProfileApp from "../assets/images/dashboard/Profile.png";
import PlanBudgetApp from "../assets/images/dashboard/planbudget.png";
import MonitorReportApp from "../assets/images/dashboard/monitorreport.png";
import SponsorshipApp from "../assets/images/dashboard/sponsorship.png";
import ExperienceApp from "../assets/images/dashboard/experience.png";
import AdminApp from "../assets/images/dashboard/Admin.png";
import AdminDisabled from "../assets/images/Admindisabled.svg";
import DesignPlanDisabled from "../assets/images/designplandisabled.svg";
import ProfileDisabled from "../assets/images/Profiledisabled.svg";
import SponsorshipDisabled from "../assets/images/Sponsorshipdisabled.svg";
import ProfileAppActive from "../assets/images/dashboard/ProfileActive.png";
import PlanBudgetAppActive from "../assets/images/dashboard/planbudgetActive.png";
import MonitorReportAppActive from "../assets/images/dashboard/monitorreportActive.png";
import SponsorshipAppActive from "../assets/images/dashboard/sponsorshipActive.png";
import ExperienceAppActive from "../assets/images/dashboard/ExperienceActive.png";
import AdminAppActive from "../assets/images/dashboard/AdminActive.png";
import ExperienceJourneydisabled from "../assets/images/ExperienceJourneydisabled.svg";
import ExperienceJourneyActive from "../assets/images/Experience Journey-Solid_1.svg";
import ExperienceJourneyInactive from "../assets/images/Experience Journey_1.svg";
import DocumentRepoApp from "../assets/images/dashboard/DocumentRepo.png";
import DocumentRepoAppActive from "../assets/images/dashboard/DocumentRepoActive.png";
import DocumentRepoDisabled from "../assets/images/dashboard/DocumentRepoDisabled.png";
import MonitorReportAppDisabled from "../assets/images/dashboard/M&R-disabled.png";
import ReportsInsights from "../assets/images/dashboard/reportsInsights.png";
import ReportsInsightsActive from "../assets/images/dashboard/reportsInsightsActive.png";
import ReportsInsightsDisabled from "../assets/images/dashboard/reportsInsightsDisabled.png";

const appListConfig = [{
    code: "ADM",
    icon: AdminApp,
    iconActive: AdminAppActive,
    iconDisabled: AdminDisabled,
},{
    code: "MERL",
    icon: PlanBudgetApp,
    iconActive: PlanBudgetAppActive,
    iconDisabled: DesignPlanDisabled,
},{
    code: "PRO",
    icon: ProfileApp,
    iconActive: ProfileAppActive,
    iconDisabled: ProfileDisabled,
},{
    code: "SPON",
    icon: SponsorshipApp,
    iconActive: SponsorshipAppActive,
    iconDisabled: SponsorshipDisabled,
},{
    code: "EXPJRNY",
    icon: ExperienceJourneyInactive, 
    iconActive: ExperienceAppActive ,
    iconDisabled: ExperienceJourneydisabled,
},{
    code: "MON",
    icon: MonitorReportApp,
    iconActive: MonitorReportAppActive,
    iconDisabled: MonitorReportAppDisabled,
},{
    code: "DOC",
    icon: DocumentRepoApp,
    iconActive: DocumentRepoAppActive,
    iconDisabled: DocumentRepoDisabled,
},{
    code: "INSTRPT",
    icon: ReportsInsights,
    iconActive: ReportsInsightsActive,
    iconDisabled: ReportsInsightsDisabled,
}
// {
//     code: "PMT",
//     icon: ReportsInsights,
//     iconActive: ReportsInsightsActive,
//     iconDisabled: ReportsInsightsDisabled,
// }
];


const appListStyleConfig = [
    {
        index:0,
        margin: "104px",
        className: ""
    },
    {
        index:1,
        margin: "70px",
        className: ""
    },
    {
        index:2,
        margin: "43px",
        className: ""
    },
    {
        index:3,
        margin: "39px",
        className: ""
    },
    {
        index:4,
        margin: "45px",
        className: ""
    },
    {
        index:5,
        margin: "59px",
        className: ""
    },
    {
        index:6,
        margin: "85px",
        className: ""
    },
    {
        index:7,
        margin: "118px",
        className: ""
    }
    //  {
    //     index:8,
    //     margin: "118px",
    //     className: ""
    // }
];

const getAppListConfig = (appCode: string) => {
    return appListConfig.find(app => app.code === appCode);
};

export { appListConfig, appListStyleConfig };

export { getAppListConfig };
